import "swiper/swiper-bundle.css";
import Swiper from "swiper/swiper-bundle.esm.js";
// import customEffect from "./home-effect";
// Swiper.use([customEffect]);
export default Swiper;



// WEBPACK FOOTER //
// ./src/components/swiper/swiper.js